<template>
  <div class="content">
    <template>
      <v-card
        :style="$vuetify.breakpoint.xs
          ? 'margin: 4px'
          : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />

        <div v-if="!loading">
          <crud-list
            v-model="setores"
            :headers="headers"
            :actions="actions"
            :sort-by="['descricao']"
            :sort-desc="[false]"
            export-pdf-xlsx
          >
            <template v-slot:btnCadastro>
              <v-col>
                <v-btn
                  block
                  class="text-none text-white"
                  color="primary"
                  title="Cadastrar novo setor"
                  rounded
                  @click="$router.push({ path: 'setores/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import SetoresStore, { BOOTSTRAP, INATIVAR_SETOR } from '@/store/modules/setores'
  import { mapState, mapActions } from 'vuex'

  export default {
    data () {
      return {
        actions: [
          {
            title: 'Editar Setor',
            color: 'info darken-3',
            click: item => this.editarSetor(item),
            icon: 'mdi-pencil',
            permission: 'editar_setor',
          },
          {
            title: 'Deletar Setor',
            color: 'red darken-3',
            click: item => this.INATIVAR_SETOR(item),
            icon: 'mdi-trash-can-outline',
            permission: 'editar_setor',
          },
        ],
        headers: [
          { text: '', value: 'actions', sortable: false, groupable: false, width: '100' },
          { align: 'left', sortable: true, groupable: false, text: 'Descrição', value: 'descricao', width: 'auto', report: true },
        ],

      }
    },
    computed: {
      ...mapState('setores', ['loading', 'setores']),
    },
    async created () {
      if (!this.$store.hasModule('setores')) { this.$store.registerModule('setores', SetoresStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('setores', [BOOTSTRAP, INATIVAR_SETOR]),
      editarSetor ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/setores/alterar/`,
          query: { id },
        })
      },
    },
  }
</script>
